/** Service code of the Generate Video group in GET /v1/me/services. */
export const GENERATE_VIDEO_SERVICE_CODE = 'generate_video';

/** Polling: start at the server's Retry-After, grow by this factor per poll, up to the cap. */
export const JOB_POLL_BACKOFF_FACTOR = 1.5;
export const JOB_POLL_MAX_SECONDS = 15;

export const JOB_PAGE_SIZE = 12;

export const ACTIVE_JOB_STATUSES = ['queued', 'running'] as const;
